// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"a83cfd582ab089053ecf","293":"9674c1091522f034d227","518":"66d964a596d374f65c39","779":"31ec46a3ade62dabe03c"}[chunkId] + ".js";
};